import { DatePipe } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { NgxPermissionsService } from 'ngx-permissions';
import { lastValueFrom, map } from 'rxjs';
import {
  CategorySummaryDTO,
  ProductControllerService
} from 'src/app/admin-api';
import { TableColumn } from 'src/app/components/table';
import { Role, roleAsObject } from 'src/app/models';
import { AppDialogService } from 'src/app/services/dialog.service';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss'],
  providers: [DatePipe]
})
export class CategoriesComponent implements OnInit {
  private title = inject(Title);
  public productService = inject(ProductControllerService);
  private ngxPermissionsService = inject(NgxPermissionsService);

  cols: Array<TableColumn> = [
    new TableColumn('Id', 'categoryId', true, 'number', '', 'categoryId'),
    new TableColumn(
      'Id Externo',
      'externalIdString',
      true,
      'text',
      '',
      'categoryId',
      true,
      'contains'
    ),
    new TableColumn(
      'Categoria',
      'category',
      true,
      'text',
      '',
      'categoryId',
      true,
      'contains'
    ),
    new TableColumn(
      'Subcategorias',
      'subcategories',
      false,
      'formattedInteger'
    ),
    new TableColumn('Produtos', 'products', false, 'formattedInteger')
  ];
  permission = false;
  categories: Array<CategorySummaryDTO>;
  searchForm: FormGroup | undefined;

  async ngOnInit(): Promise<void> {
    this.title.setTitle('Produtos de assinatura - Categorias');
    this.permission = await this.ngxPermissionsService.hasPermission([
      roleAsObject(Role.Full_Administrator).enumValue,
      roleAsObject(Role.Admin_Allocation).enumValue,
      roleAsObject(Role.User_Allocation).enumValue
    ]);
    await this.findCategoriesTable();
  }

  async findCategoriesTable(): Promise<void> {
    try {
      this.categories = await lastValueFrom(
        this.productService
          .findProductCategoriesTable()
          .pipe(map((data) => data.result))
      );
    } catch (error) {
      this.categories = [];
      AppDialogService.showErrorDialog(error);
    }
  }
}
